/** 接受原生 localStorage 格式，以及旧版 Taro H5 的 data 包装。 */
export function parseStoredSession(raw) {
    try {
        if (typeof raw !== 'string' || !raw)
            return null;
        let value = JSON.parse(raw);
        if (typeof value === 'object' && value !== null && 'data' in value) {
            if (typeof value.data !== 'string')
                return null;
            value = JSON.parse(value.data);
        }
        if (typeof value !== 'object' || value === null)
            return null;
        const s = value;
        if (s.expiresAt !== undefined &&
            (typeof s.expiresAt !== 'string' ||
                !Number.isFinite(Date.parse(s.expiresAt)) ||
                Date.parse(s.expiresAt) <= Date.now()))
            return null;
        return typeof s.token === 'string' &&
            s.token.length > 0 &&
            typeof s.user?.id === 'string' &&
            s.user.id.length > 0 &&
            typeof s.user.name === 'string' &&
            (s.user.role === 'owner' || s.user.role === 'member') &&
            typeof s.user.isQuotationSupervisor === 'boolean' &&
            typeof s.tenant?.id === 'string' &&
            s.tenant.id.length > 0 &&
            typeof s.tenant.name === 'string'
            ? s
            : null;
    }
    catch {
        return null;
    }
}
//# sourceMappingURL=session.js.map